import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    packageConfigurationList: [],
};

const getters = {
    packageConfigurationList: state => state.packageConfigurationList,
};

const mutations = {
    setPackageConfigurationList(state, data) {
        state.packageConfigurationList = data;
    },
};

const actions = {
    async getPackageConfigurationList({ commit, dispatch }) {
        let route = Laroute.route(
            'franchise.inventory.measurement.package_configuration.list',
        );

        startLoading(dispatch, 'list');

        return axios
            .post(route)
            .then(res => {
                commit('setPackageConfigurationList', res.data.data);
                endLoading(dispatch, 'list');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'list');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
